import { render, staticRenderFns } from "./OfferSaleBase.vue?vue&type=template&id=713f6d9c&scoped=true"
import script from "./OfferSaleBase.vue?vue&type=script&lang=js"
export * from "./OfferSaleBase.vue?vue&type=script&lang=js"
import style0 from "./OfferSaleBase.vue?vue&type=style&index=0&id=713f6d9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713f6d9c",
  null
  
)

export default component.exports